module.exports = "<base href=\"/\">\r\n<app-header></app-header>\r\n<div class=\"mt-2 mx-sm-auto mx-md-2 mx-lg-4 row\">\r\n  <div class=\"col-xl-12\">\r\n      <app-content-container></app-content-container>\r\n  </div>\r\n</div>\r\n<app-footer></app-footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/main-content/main-content.component.html
// module id = ./src/app/main-content/main-content.component.html
// module chunks = main